import { Component, Input } from '@angular/core';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { UserInfo } from 'src/app/modules/shared/models/form/user-info.model';
import { OrganizationType } from 'src/app/modules/shared/models/staff/organization-type.enum';
import { User } from 'src/app/modules/shared/models/staff/user.model';

@Component({
  selector: 'app-dialog-jtys105-sp3',
  templateUrl: './dialog-jtys105-sp3.component.html',
  styleUrls: ['./dialog-jtys105-sp3.component.scss'],
})
export class DialogJtys105Sp3Component {
  @Input() data!: DialogConfig<{
    userList: User[];
    no_1_User: UserInfo;
    no_2_User: UserInfo;
    no_9_UserId: string;
    no_10_UserId: string;
    no_11_UserId: string;
    no_12_UserId: string;
    no_13_UserId: string;
    suUserId: string;
  }>;

  selectedUserMap: { [key: string]: string } = {};
  userTreeNodesMap: { [key: string]: User[] } = {};

  no_1_DepartmentId: string = '';
  no_1_DepartmentName: string = '';

  no_2_userId: string = '';
  no_9_userId: string = '';
  no_10_userId: string = '';

  no_11_UserId: string = '';
  no_12_UserId: string = '';
  no_13_UserId: string = '';
  suUserId: string = '';

  departments: {
    label: string;
    value: string;
    checked: boolean;
  }[] = [];

  subSu: User[] = [];
  su: User[] = [];

  userList: User[] = [];
  noNeedRest: boolean = false;

  constructor() {}

  ngOnInit() {
    this.prepareData();
  }

  private prepareData() {
    // 然后根据单位id来过滤用户列表，获取建设单位的用户列表
    const users = this.data
      .data!.userList.filter(
        (user) => user.organizationType === OrganizationType.DEVELOPMENT,
      )
      .sort((a, b) => +b.postSortOrder! - +a.postSortOrder!);

    this.userList = users;
    this.no_1_DepartmentId = this.data.data!.no_1_User.departmentId!.toString();
    this.no_1_DepartmentName = this.data.data!.no_1_User.departmentName!;

    const departmentsUserMap: { [key: string]: User[] } = {};
    const departments: { label: string; value: string; checked: boolean }[] =
      [];
    const subSu: User[] = [];
    const su: User[] = [];

    for (const user of users) {
      if (!departmentsUserMap[user.departmentId!]) {
        departmentsUserMap[user.departmentId!] = [];
        // 排除主办部门和领导类部门
        if (`${user.departmentId}` !== `${this.no_1_DepartmentId}`) {
          if (!user.departmentName!.includes('领导')) {
            departments.push({
              label: user.departmentName!,
              value: user.departmentId!.toString(),
              checked: false,
            });
          }
        }
      }
      departmentsUserMap[`${user.departmentId!}`].push(user);
      if (!this.selectedUserMap[`${user.departmentId!}`]) {
        this.selectedUserMap[`${user.departmentId!}`] = user.id!.toString();
      }

      // 搜集副指挥长和指挥长
      if (user.postName!.includes('副指挥长')) {
        subSu.push(user);
      } else if (user.postName!.includes('指挥长')) {
        su.push(user);
      }
    }

    this.subSu = subSu;
    this.su = su;
    this.userTreeNodesMap = departmentsUserMap;
    this.departments = departments;

    // 初始化经办人2、负责人1、负责人2
    this.no_2_userId = '';
    this.no_10_userId = this.data.data!.no_10_UserId || '';
    this.no_9_userId = '';

    // 初始化会签领导：N=11、12、13、14
    this.no_11_UserId = this.data.data!.no_11_UserId || '';
    this.no_12_UserId = this.data.data!.no_12_UserId || '';
    this.no_13_UserId = this.data.data!.no_13_UserId || '';
    this.suUserId = this.data.data!.suUserId || '';

    // 按部门推荐 N=11 分管副指挥长（复用 sp1 逻辑）
    this.recommendNo11User();

    // 验证并清理副指挥长数据
    this.validateSubSuData();
    this.validateSuData();
  }

  private recommendNo11User() {
    const departmentName = this.no_1_DepartmentName;
    if (departmentName === '工程部' || departmentName === '总师办') {
      const userName = location.href.includes('sanqiao.hzsksc.com')
        ? '徐建平'
        : '王晨';
      const user = this.subSu.find((i) => i.name === userName);
      if (user) {
        this.no_11_UserId = user.id!.toString();
      }
    }
    if (departmentName === '党建纪检办公室') {
      const userName = location.href.includes('sanqiao.hzsksc.com')
        ? '陈文俊'
        : '吴桃';
      const user = this.subSu.find((i) => i.name === userName);
      if (user) {
        this.no_11_UserId = user.id!.toString();
      }
    }
    if (
      departmentName === '前期部' ||
      departmentName === '安全部' ||
      departmentName === '综合办' ||
      departmentName === '财务部'
    ) {
      const userName = location.href.includes('sanqiao.hzsksc.com')
        ? '张科峰'
        : '徐丹';
      const user = this.subSu.find((i) => i.name === userName);
      if (user) {
        this.no_11_UserId = user.id!.toString();
      }
    }
  }

  private validateSubSuData() {
    if (this.subSu.length === 0) {
      this.no_11_UserId = '';
      this.no_12_UserId = '';
      this.no_13_UserId = '';
      return;
    }

    // 验证 no_12_UserId
    let contain = false;
    for (const u of this.subSu) {
      if (`${u.id}` === `${this.no_12_UserId}`) {
        contain = true;
        break;
      }
    }
    if (!contain) {
      this.no_12_UserId = '';
    }

    // 验证 no_13_UserId
    contain = false;
    for (const u of this.subSu) {
      if (`${u.id}` === `${this.no_13_UserId}`) {
        contain = true;
        break;
      }
    }
    if (!contain) {
      this.no_13_UserId = '';
    }
  }

  private validateSuData() {
    if (this.su.length === 0) {
      this.suUserId = '';
      return;
    }

    let contain = false;
    for (const u of this.su) {
      if (`${u.id}` === `${this.suUserId}`) {
        contain = true;
        break;
      }
    }
    if (!contain) {
      this.suUserId = '';
    }
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    // 经办人2 UserInfo
    const no_2_UserInfoList: UserInfo[] = [];
    if (this.no_2_userId) {
      const userInfo = new UserInfo();
      const user = this.userList.find(
        (user) =>
          `${user.id}` === `${this.no_2_userId}` &&
          `${user.departmentId}` === `${this.no_1_DepartmentId}`,
      );
      if (user) {
        userInfo.organizationType = user.organizationType;
        userInfo.organizationId = user.organizationId;
        userInfo.organizationShortName = user.organizationShortName;
        userInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        userInfo.userName = user.name;
        userInfo.departmentId = user.departmentId;
        userInfo.departmentName = user.departmentName;
        userInfo.postId = user.postId;
        userInfo.userId = user.id;
        userInfo.postName = user.postName;
        userInfo.postPerformance = user.postPerformance;
        userInfo.performance = user.performance;
        userInfo.sealHolder = user.sealHolder;
        no_2_UserInfoList.push(userInfo);
      }
    }

    // 负责人1 UserInfo
    const no_10_UserInfoList: UserInfo[] = [];
    if (this.no_10_userId) {
      const userInfo = new UserInfo();
      const user = this.userList.find(
        (user) =>
          `${user.id}` === `${this.no_10_userId}` &&
          `${user.departmentId}` === `${this.no_1_DepartmentId}`,
      );
      if (user) {
        userInfo.organizationType = user.organizationType;
        userInfo.organizationId = user.organizationId;
        userInfo.organizationShortName = user.organizationShortName;
        userInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        userInfo.userName = user.name;
        userInfo.departmentId = user.departmentId;
        userInfo.departmentName = user.departmentName;
        userInfo.postId = user.postId;
        userInfo.userId = user.id;
        userInfo.postName = user.postName;
        userInfo.postPerformance = user.postPerformance;
        userInfo.performance = user.performance;
        userInfo.sealHolder = user.sealHolder;
        no_10_UserInfoList.push(userInfo);
      }
    }

    // 负责人2 UserInfo
    const no_9_UserInfoList: UserInfo[] = [];
    if (this.no_9_userId) {
      const userInfo = new UserInfo();
      const user = this.userList.find(
        (user) =>
          `${user.id}` === `${this.no_9_userId}` &&
          `${user.departmentId}` === `${this.no_1_DepartmentId}`,
      );
      if (user) {
        userInfo.organizationType = user.organizationType;
        userInfo.organizationId = user.organizationId;
        userInfo.organizationShortName = user.organizationShortName;
        userInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        userInfo.userName = user.name;
        userInfo.departmentId = user.departmentId;
        userInfo.departmentName = user.departmentName;
        userInfo.postId = user.postId;
        userInfo.userId = user.id;
        userInfo.postName = user.postName;
        userInfo.postPerformance = user.postPerformance;
        userInfo.performance = user.performance;
        userInfo.sealHolder = user.sealHolder;
        no_9_UserInfoList.push(userInfo);
      }
    }

    // 会签部门列表
    const restUserInfoList: UserInfo[] = [];
    if (!this.noNeedRest) {
      for (const department of this.departments) {
        if (!department.checked) {
          continue;
        }
        const userId = this.selectedUserMap[`${department.value}`];
        const userInfo = new UserInfo();
        const user = this.userList.find(
          (user) =>
            `${user.id}` === `${userId}` &&
            `${user.departmentId}` === `${department.value}`,
        );
        if (user) {
          userInfo.organizationType = user.organizationType;
          userInfo.organizationId = user.organizationId;
          userInfo.organizationShortName = user.organizationShortName;
          userInfo.organizationName =
            user.organizationShortName ?? user.organizationName;
          userInfo.userName = user.name;
          userInfo.departmentId = user.departmentId;
          userInfo.departmentName = user.departmentName;
          userInfo.postId = user.postId;
          userInfo.userId = user.id;
          userInfo.postName = user.postName;
          userInfo.postPerformance = user.postPerformance;
          userInfo.performance = user.performance;
          userInfo.sealHolder = user.sealHolder;
          restUserInfoList.push(userInfo);
        }
      }
    }

    // N=11 分管副指挥长
    const no_11_UserInfo = new UserInfo();
    if (this.no_11_UserId) {
      const user = this.userList.find(
        (user) => `${user.id}` === `${this.no_11_UserId}`,
      );
      if (user) {
        no_11_UserInfo.organizationType = user.organizationType;
        no_11_UserInfo.organizationId = user.organizationId;
        no_11_UserInfo.organizationShortName = user.organizationShortName;
        no_11_UserInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        no_11_UserInfo.userName = user.name;
        no_11_UserInfo.departmentId = user.departmentId;
        no_11_UserInfo.departmentName = user.departmentName;
        no_11_UserInfo.postId = user.postId;
        no_11_UserInfo.userId = user.id;
        no_11_UserInfo.postName = user.postName;
        no_11_UserInfo.postPerformance = user.postPerformance;
        no_11_UserInfo.performance = user.performance;
        no_11_UserInfo.sealHolder = user.sealHolder;
      }
    }

    // N=12 其他副指挥长1
    const no_12_UserInfo = new UserInfo();
    if (this.no_12_UserId) {
      const user = this.userList.find(
        (user) => `${user.id}` === `${this.no_12_UserId}`,
      );
      if (user) {
        no_12_UserInfo.organizationType = user.organizationType;
        no_12_UserInfo.organizationId = user.organizationId;
        no_12_UserInfo.organizationShortName = user.organizationShortName;
        no_12_UserInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        no_12_UserInfo.userName = user.name;
        no_12_UserInfo.departmentId = user.departmentId;
        no_12_UserInfo.departmentName = user.departmentName;
        no_12_UserInfo.postId = user.postId;
        no_12_UserInfo.userId = user.id;
        no_12_UserInfo.postName = user.postName;
        no_12_UserInfo.postPerformance = user.postPerformance;
        no_12_UserInfo.performance = user.performance;
        no_12_UserInfo.sealHolder = user.sealHolder;
      }
    }

    // N=13 其他副指挥长2
    const no_13_UserInfo = new UserInfo();
    if (this.no_13_UserId) {
      const user = this.userList.find(
        (user) => `${user.id}` === `${this.no_13_UserId}`,
      );
      if (user) {
        no_13_UserInfo.organizationType = user.organizationType;
        no_13_UserInfo.organizationId = user.organizationId;
        no_13_UserInfo.organizationShortName = user.organizationShortName;
        no_13_UserInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        no_13_UserInfo.userName = user.name;
        no_13_UserInfo.departmentId = user.departmentId;
        no_13_UserInfo.departmentName = user.departmentName;
        no_13_UserInfo.postId = user.postId;
        no_13_UserInfo.userId = user.id;
        no_13_UserInfo.postName = user.postName;
        no_13_UserInfo.postPerformance = user.postPerformance;
        no_13_UserInfo.performance = user.performance;
        no_13_UserInfo.sealHolder = user.sealHolder;
      }
    }

    // N=14 指挥长
    const suUserInfo = new UserInfo();
    if (this.suUserId) {
      const user = this.userList.find(
        (user) => `${user.id}` === `${this.suUserId}`,
      );
      if (user) {
        suUserInfo.organizationType = user.organizationType;
        suUserInfo.organizationId = user.organizationId;
        suUserInfo.organizationShortName = user.organizationShortName;
        suUserInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        suUserInfo.userName = user.name;
        suUserInfo.departmentId = user.departmentId;
        suUserInfo.departmentName = user.departmentName;
        suUserInfo.postId = user.postId;
        suUserInfo.userId = user.id;
        suUserInfo.postName = user.postName;
        suUserInfo.postPerformance = user.postPerformance;
        suUserInfo.performance = user.performance;
        suUserInfo.sealHolder = user.sealHolder;
      }
    }

    this.data.onConfirm!({
      userInfoList: restUserInfoList,
      no_2_UserInfoList,
      no_9_UserInfoList,
      no_10_UserInfoList,
      no_11_User: no_11_UserInfo,
      no_12_User: no_12_UserInfo,
      no_13_User: no_13_UserInfo,
      suUser: suUserInfo,
    });
  }

  get canConfirm() {
    // 负责人1必填
    if (!this.no_10_userId) {
      return false;
    }

    // 会签部门校验
    if (!this.noNeedRest) {
      let count = 0;
      for (const department of this.departments) {
        if (department.checked) {
          count++;
          if (!this.selectedUserMap[`${department.value}`]) {
            return false;
          }
        }
      }
      // 至少选1个，最多6个
      if (count === 0 || count > 6) {
        return false;
      }
    }

    return true;
  }
}
